/**
 * Should return the properly formatted address for a majority of countries
 * @param formattedAddress Complete formatted address string
 * @returns Formatted street address string
 */
function getFormattedStreetAddress(formattedAddress: string): string {
	const addressChunks = formattedAddress.split(', ');

	// Edge-case for UAE, as they use hyphens to separate. Will require better logic if other non-comma cases are found.
	if (addressChunks.length === 1) {
		return formattedAddress.split(' - ')[0] ?? '';
	}

	// Regex ensures there's a digit in the string.
	// Originally excluded cases like '2nd', but returned to just digits due to cases like street number '17A' (Australia)
	const regexContainsHouseNumber = /\d+/g;

	// In observed cases, if street number isn't in the first section, it might be in the next section
	if (addressChunks[0] && addressChunks[1] && !regexContainsHouseNumber.test(addressChunks[0]) && regexContainsHouseNumber.test(addressChunks[1])) {
		return `${addressChunks[0]}, ${addressChunks[1]}`;
	}

	// Otherwise, first section is most likely correct
	return addressChunks[0] ?? '';
}

export {
	getFormattedStreetAddress,
};
